import React from 'react';

import { Container } from './styles';

export const NotFound = () => {
  return (
    <Container>
      <p>Pagina não encontrada!</p>
    </Container>
  );
};

export default NotFound;
